<script lang="ts" setup>
import { defineAsyncComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useSports } from '~/composables/sports/use-sports'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import { useScrollIntoView } from '~/utils'
import { SportsTabs } from '~composables/sports/interface'

const SchedulesSports = defineAsyncComponent(async () => await import('./schedules.vue'))
const News = defineAsyncComponent(async () => await import('./../home/news.vue'))

const route = useRoute()
const WrapperSchedulesSports = defineAsyncComponent(async () => await import('./wrapper.vue'))

const { tabSelected, playSport } = useSports()
const scheduleRef = ref<HTMLDivElement | null>()

onMounted(() => {
  if (route.path.includes(LOBBY_GAME_URLS.SPORTS)) {
    setTimeout(() => {
      useScrollIntoView(scheduleRef.value)
    }, 100)
  }
})
</script>

<template>
  <div ref="scheduleRef" class="page-lobby-sports">
    <WrapperSchedulesSports>
      <SchedulesSports v-if="tabSelected === SportsTabs.SPORT" @playSport="playSport" />
      <News />
    </WrapperSchedulesSports>
  </div>
</template>

<style scoped lang="scss">
.page-lobby-sports {
  scroll-margin-top: $header-height-desktop-xl;
  @include media-query(max, $size-container-xl) {
    scroll-margin-top: $header-height-desktop;
  }
}
</style>
